import React, { useState } from "react";
import { Link } from "react-router-dom";
import towing from "../../assets/images/towing.svg";
import Whitelogo from "../../assets/images/White-logo.svg";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { APIURL } from "./../../redux/action/config";
import OTPInput from "otp-input-react";

const VerifyOTP = () => {
  const [OTP, setOTP] = useState("");
  const phone = localStorage.getItem("phone");

  const resendOTP = () => {
    // const regex = /^([+]\d{2})?\d{12}$/;
    // if (regex.test(phone)) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      phone: `${phone}`,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/users/resendOTP`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          toast.success(result.message);
          // alert(result.otp);
        }
      })
      .catch((error) => console.log("error", error));
    // } else {
    //   toast.error("Please enter a valid phone number!");
    // }
  };
  return (
    <React.Fragment>
      <div className="d-flex flex-column flex-root">
        <ToastContainer autoClose={2000} />
        <div className="d-flex flex-column flex-lg-row flex-column-fluid">
          <div
            className="d-flex flex-column flex-lg-row-auto bg-primary w-xl-600px positon-xl-relative banner-height"
            style={{ height: "100vh" }}
          >
            <div className="d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y">
              <div className="d-flex flex-row-fluid flex-column text-center p-10 pt-lg-20">
                <Link to="#" className="py-9 pt-lg-20">
                  <img alt="Logo" src={Whitelogo} className="h-40px" />
                </Link>
                <h1 className="fw-bolder text-white fs-2qx pb-5 pb-md-10">
                  Welcome to Roadside
                </h1>
                <p className="fw-bold fs-2 text-white">
                  Emergency Roadside Assistance for Every Bahamas Motorist
                </p>
              </div>
              <div
                className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px"
                style={{
                  backgroundImage: `url(${towing})`,
                }}
              ></div>
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row-fluid py-10">
            <div className="d-flex flex-center flex-column flex-column-fluid mb-20">
              <div className="w-lg-500px p-10 p-lg-15 mx-auto w-100">
                <Formik
                  initialValues={{
                    phone: phone,
                    otp: "",
                  }}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    const data = Object.values(OTP);
                    const otp = data.join("");

                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");

                    var raw = JSON.stringify({
                      phone: values.phone,
                      otp: otp,
                    });

                    var requestOptions = {
                      method: "POST",
                      headers: myHeaders,
                      body: raw,
                      redirect: "follow",
                    };

                    fetch(
                      `${APIURL}/api/v1/users/verfifyForgotPasswordOTP`,
                      requestOptions
                    )
                      .then((response) => response.json())
                      .then((result) => {
                        if (result.status === "success") {
                          toast.success(result.message);
                          setTimeout(() => {
                            localStorage.removeItem("phone");
                            return (window.location.href = `/change-password/${result.id}`);
                          }, 1000);
                          //
                          setSubmitting(false);
                          resetForm();
                        } else {
                          toast.error(result.message);
                        }
                      })
                      .catch((error) => console.log("error", error));
                  }}
                >
                  {({
                    values,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                  }) => (
                    <form
                      className="form  w-100"
                      onSubmit={handleSubmit}
                      id="myForm"
                    >
                      <div className="text-center mb-10">
                        <h1 className="text-dark mb-3">Forgot Password ?</h1>
                        <div className="text-gray-400 fw-bold fs-4">
                          Enter OTP to match password
                        </div>
                      </div>
                      <div className="fv-row mb-10 text-center">
                        <label className="form-label text-dark fw-bold fw-bolder fs-4 mb-2">
                          Enter OTP
                        </label>
                        <div className="otp-input-section d-flex flex-row justify-content-center">
                          <OTPInput
                            value={OTP}
                            onChange={setOTP}
                            autoFocus
                            OTPLength={4}
                            otpType="number"
                            disabled={false}
                          />
                        </div>
                      </div>

                      <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                        <button
                          type="button"
                          id="kt_password_reset_submit"
                          className="btn btn-lg btn-primary fw-bolder me-4"
                          onClick={handleSubmit}
                        >
                          <span className="indicator-label">Submit</span>
                          <span className="indicator-progress">
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        </button>
                        <Link
                          to="#"
                          onClick={resendOTP}
                          className="btn-light-primary fw-bolder align-items-center d-flex text-decoration-underline"
                        >
                          Resend OTP
                        </Link>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
              <div className="d-flex flex-center fw-bold fs-6">
                <p>
                  (new Date()?.getFullYear()) © Copyright All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default VerifyOTP;
